import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaShieldAlt, FaChartLine, FaLock, FaGem, FaGlobe } from "react-icons/fa";
import JsonData from "../data/data.json";

/* Ordem casa com brandPillars.items nos locales e com o manual da marca. */
const ICONS = [FaShieldAlt, FaChartLine, FaLock, FaGem, FaGlobe];

export const BrandPillars = () => {
  const { t, i18n } = useTranslation("landing");
  const brand = JsonData?.About?.nameBank || "CIRYON";
  const items = t("brandPillars.items", { returnObjects: true });

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: 0 }
    );

    document
      .querySelectorAll(".brand-pillars .reveal")
      .forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [i18n.language]);

  if (!Array.isArray(items)) return null;

  return (
    <section className="brand-pillars" id="brand-pillars">
      <div className="brand-pillars__head">
        <h2 className="brand-pillars__title reveal">{t("brandPillars.title")}</h2>
        <p className="brand-pillars__subtitle reveal">
          {t("brandPillars.subtitle", { brand })}
        </p>
      </div>

      <div className="brand-pillars__grid">
        {items.map((item, index) => {
          const Icon = ICONS[index] || FaGem;
          return (
            <article key={index} className="brand-pillar reveal">
              <span className="brand-pillar__icon">
                <Icon />
              </span>
              <h3 className="brand-pillar__name">{item.name}</h3>
              <p className="brand-pillar__text">{item.text}</p>
            </article>
          );
        })}
      </div>
    </section>
  );
};
